import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error?.header || error;
		}
	},
	async getList_({ commit, state }) {
		try {
			const { searchParams } = state;
			const data = await api.getList({ searchParams });
			if (data?.header?.code === 0) {
				const { resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data?.header;
		} catch (error) {
			throw error?.header || error;
		}
	},
	async getDetail_({ commit, state }, cofCd) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getDetail({ searchParams, cofCd, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data?.header?.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'detailList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data?.header;
		} catch (error) {
			throw error?.header || error;
		}
	},
	async getGraph_({ commit, state }) {
		try {
			const { searchParams } = state;
			const data = await api.getGraph({ searchParams });
			if (data?.header?.code === 0) {
				const { resultList, maxCnt } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'maxCnt', value: Math.ceil(Number(maxCnt)) });
				commit(types.DEFAULT_ASSIGN, { key: 'graphList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data?.header;
		} catch (error) {
			throw error?.header || error;
		}
	}
};
